import { Injectable } from '@angular/core';
import { FileService } from '@core/services/file.service';
import { environment } from 'environments/environment';
import { HttpService } from '../http.service';
import { ServiceBase } from '../servicebase';
import { CompanyRootModel } from 'services/models/companyRoot.model';
import { Observable } from 'rxjs';
import { Response } from 'services/models/response';
import { QueryParams } from 'services/models/odata/queryParams';
import { ObjectMapper } from 'json-object-mapper';
import { Filter } from 'services/models/odata/filter';

@Injectable()
export class CompanyRootService extends ServiceBase<CompanyRootModel> {
  constructor(
    http: HttpService,
    private file: FileService
  ) {
    super('company/company-root', http, environment.apiUrl);
  }

  createEntity(input: any): CompanyRootModel {
    return CompanyRootModel.create(input);
  }

  listCompaniesRoot(params: QueryParams = null): Observable<Response<CompanyRootModel[]>> {
    return this.customList<CompanyRootModel>(params, `list`, CompanyRootModel);
  }

  getCompaniesRootOptions(companyGroupId: string): Observable<Response<CompanyRootModel[]>> {
    const filters = [];
    filters.push(Filter.buildFilter('companyGroupId', companyGroupId));
    filters.push(Filter.buildFilter('enable', true));

    const params = {
      select: ['name', 'id', 'rootCNPJ', 'companyGroupId', 'enable'],
      orderBy: 'name',
      orderByOrder: 'asc',
      filter: Filter.multEquals(filters),
    } as QueryParams;

    return this.listCompaniesRoot(params);
  }

  saveCompanyRoot(id: string | undefined, obj: any) {
    let _object = ObjectMapper.serialize(obj);
    return id == undefined
      ? this.http.post(`${this.endpoint}`, _object)
      : this.http.put(`${this.endpoint}`, JSON.parse(_object.toString()));
  }
}
